// Copyright (c) 2016 Deere & Company

import UpdateMachineStatusHistory from '../../../reports/update-machine-status-history/state-connector';

export default {
    component: UpdateMachineStatusHistory,
    name: 'UPDATE_MACHINE_STATUS_HISTORY',
    path: 'update-machine-status-history'
};



// WEBPACK FOOTER //
// ./src/routes/products/reports/update-machine-status-history.js